import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from './components/common/authContext';
import RootLayout from './components/common/RootLayout';

//for public accessible without login======
import AboutUs from './publicAccessible/aboutUsPage'
import ContactUs from './publicAccessible/contactus/contactUsPage';

import Contact from './publicAccessible/contactus/contactUsPage';
import CreateAccount from './account/createAccountPage';
import CreateAccountByInvite from './account/createAccountByInvite'
import CreateCompany from './company/createCompayPage'
import Faq from './publicAccessible/faq/faqPage'
import ForgetPassword from './login/forgetPasswordPage';
import ResetPassword from './login/resetPasswordPage';
import NotFound from './publicAccessible/NotFoundPage';


import HomePage from './home/homePage';
import Login from './login/loginPage'
import OurStory from './publicAccessible/ourStoryPage'
import PrivacyPolicy from './publicAccessible/privacyPolicyPage';

import TermsOfUse from './publicAccessible/termsOfUse'
import Timecard from './timecard/timecardPage'


//end of public accessible =========


import JobSite from './jobsite/jobsitePage';
import Employee from './employee/employeePage'


import Main from './home/main';
//for the main menu Customer======
import Customer from './customer/customerPage';
import UpdateCustomer from './customer/updateCustomerPage';
import DeleteCustomer from './customer/deleteCustomerPage';
import CreateCustomer from './customer/createCustomerPage';
import SendEstimate from './customer/sendEstimatePage';
import DocumentsSent from './customer/documentSentPage';


//for the main menu Project======
import Project from './project/projectPage';
import CreateProject from './project/createProjectPage'
import UpdateProject from './project/updateProjectPage'
import DeleteProject from './project/deleteProjectPage'

import PhotoGallery from './photo/photoPage'
import UploadPhoto from './photo/uploadPhotoPage'

import CreateJobsite from './jobsite/createJobsitePage'
import UpdateJobsite from './jobsite/updateJobsitePage'
import DeleteJobsite from './jobsite/deleteJobsitePage'

//for the  menu Estimate======
import Estimate from './estimate/estimatePage';
import CreateEstimate from './estimate/createEstimatePage';
import UpdateEstimate from './estimate/updateEstimatePage';
import DeleteEstimate from './estimate/deleteEstimatePage';
import EstimateToCustomer from './estimate/estimateToCustomerPage'
import SmartEstimateAssistant from './estimateEngine/smartAIEstimateAssistantPage'
import SmartGeneratedEstimate from './estimateEngine/smartGeneratedEstimatePage'

import Donations from './donations/Donation'
import CreateDonation from './donations/CreateDonation'

import InvoiceToCustomer from './invoice/invoiceToCustomerPage'
import InvoiceToQuickbooks from './invoice/invoiceToQuickbooks'

//for the  menu Invoice======
import Invoice from './invoice/invoicePage';
import CreateInvoice from './invoice/createInvoicePage';
import UpdateInvoice from './invoice/updateInvoicePage';

import Company from './company/companyPage';
import UpdateCompany from './company/updateCompanyPage'
import DeleteInvoice from './invoice/deleteInvoicePage';

import OnlineAccount from './account/accountPage'
import UpdateOnlineAccount from './account/updateAccountPage'
import OnlineAccountInvite from './account/accountInvitePage'
import Subscription from './subscription/subscriptionPage'
import RefundSubscriptionPayment from './subscription/refundPaymentPage'
import MakePayment from './subscription/makePaymentPage'
import ViewPayment from './subscription/viewPaymentPage'
import AccountSettings from './account/accountSettingPage'


import ForTesting from './account/testPage';



import CreateEmployee from './employee/createEmployeePage'
import UpdateEmployee from './employee/updateEmployee'
import DeleteEmployee from './employee/deleteEmployeePage'
import SendEmployeeTimecard from './timecard/sendTimecardPage'

import EmployeeTimeCardReport from './timecard_report/timecardReportPage';

import UpdateCustomerPayment from './customerPayment/updateCustomerPayment';
import DeleteCustomerPayment from './customerPayment/deleteCustomerPayment';
import CustomerPayment from './customerPayment/customerPayment';
import CreateCustomerPayment from './customerPayment/createCustomerPayment';
import SendPaymentStatement from './customerPayment//sendPaymentStatement';
import QuickbooksPopup from './quickbooksConnection/quickbooksConnectPopup'

const App: React.FC = () => {
  return (



    <AuthProvider>
      <Router>

        <Routes>
          {/* Public routes - no auth needed */}
          <Route element={<RootLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/pub/about_us" element={<AboutUs />} />

            <Route path="/pub/contact_us" element={<ContactUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pub/faq" element={<Faq />} />
            <Route path="/pub/our_story" element={<OurStory />} />
            <Route path="/pub/terms_of_use" element={<TermsOfUse />} />
            <Route path="/pub/privacy_policy" element={<PrivacyPolicy />} />

            <Route path="/create_account" element={<CreateAccount />} />
            <Route path="/create_account_by_invite" element={<CreateAccountByInvite />} />
            <Route path="/create_company" element={<CreateCompany />} />
            <Route path="/forget_password" element={<ForgetPassword />} />
            <Route path="/reset_password" element={<ResetPassword />} />
            <Route path="/login" element={<Login />} />
            {/* NotFound - inside RootLayout */}
            <Route path="*" element={<NotFound />} />

            <Route path="/time/:employee_code" element={<Timecard />} />
            <Route path="quickbooks/callback" element={<QuickbooksPopup />} />
          </Route>

          {/* End Public routes - no auth needed */}

          {/* Protected routes structure - all routes under /main require authentication */}
          <Route path="/main" element={<ProtectedRoute><Main /></ProtectedRoute>}>
            {/* Account routes */}
            <Route path="account" element={<OnlineAccount />} />
            <Route path="account/update" element={<UpdateOnlineAccount />} />
            <Route path="account/subscription" element={<Subscription />} />
            <Route path="account/subscription/make_payment" element={<MakePayment />} />
            <Route path="account/subscription/view_payment" element={<ViewPayment />} />
            <Route path="account/subscription/refund_payment" element={<RefundSubscriptionPayment />} />
            <Route path="account/account_invite" element={<OnlineAccountInvite />} />
            <Route path="account/settings" element={<AccountSettings />} />
      
           <Route path="testing" element={<ForTesting />} />

    

            {/* Default route for /main */}
            <Route path="/main" element={<Customer />} />

            {/* Customer routes */}
            <Route path="customer" element={<Customer />} />
            <Route path="customer/create" element={<CreateCustomer />} />
            <Route path="customer/update" element={<UpdateCustomer />} />
            <Route path="customer/delete" element={<DeleteCustomer />} />
            <Route path="customer/send_estimate" element={<SendEstimate />} />
            <Route path="customer/documents_sent" element={<DocumentsSent />} />

            {/* Project routes */}
            <Route path="project" element={<Project />} />
            <Route path="project/create" element={<CreateProject />} />
            <Route path="project/update" element={<UpdateProject />} />
            <Route path="project/delete" element={<DeleteProject />} />
            <Route path="project/jobSite" element={<JobSite />} />
            <Route path="project/jobsite/create" element={<CreateJobsite />} />
            <Route path="project/jobsite/update" element={<UpdateJobsite />} />
            <Route path="project/jobsite/delete" element={<DeleteJobsite />} />

            <Route path="project/photo" element={<PhotoGallery />} />
            <Route path="project/photo/upload" element={<UploadPhoto />} />

            {/* Estimate routes */}
            <Route path="project/estimate" element={<Estimate />} />
            <Route path="project/estimate/create" element={<CreateEstimate />} />
            <Route path="project/estimate/update" element={<UpdateEstimate />} />
            <Route path="project/estimate/delete" element={<DeleteEstimate />} />
            <Route path="project/estimate/tocustomer" element={<EstimateToCustomer />} />
            <Route path="project/estimate/smartassistant" element={<SmartEstimateAssistant />} />
            <Route path="project/estimate/smartgeneratedestimate" element={<SmartGeneratedEstimate />} />

            {/* Invoice routes */}
            <Route path="project/invoice" element={<Invoice />} />
            <Route path="project/invoice/create" element={<CreateInvoice />} />
            <Route path="project/invoice/update" element={<UpdateInvoice />} />
            <Route path="project/invoice/delete" element={<DeleteInvoice />} />
            <Route path="project/invoice/tocustomer" element={<InvoiceToCustomer />} />
            <Route path="project/invoice/toquickbooks" element={<InvoiceToQuickbooks />} />

            {/* Donations */}
            <Route path="account/donation" element={<Donations />} />
            <Route path="account/donation/create" element={<CreateDonation />} />


            {/* Customer payments */}
            <Route path="customerpayment" element={<CustomerPayment />} />
            <Route path="customerpayment/update" element={<UpdateCustomerPayment />} />
            <Route path="customerpayment/delete" element={<DeleteCustomerPayment />} />
            <Route path="customerpayment/create" element={<CreateCustomerPayment />} />
            <Route path="customerpayment/sendstatement" element={<SendPaymentStatement />} />


            {/* Company and Employee routes */}
            <Route path="company" element={<Company />} />
            <Route path="company/update" element={<UpdateCompany />} />
            <Route path="company/employee" element={<Employee />} />
            <Route path="company/employee/create" element={<CreateEmployee />} />
            <Route path="company/employee/update" element={<UpdateEmployee />} />
            <Route path="company/employee/delete" element={<DeleteEmployee />} />
            <Route path="company/employee/send_timecard" element={<SendEmployeeTimecard />} />
            <Route path="company/employee/timecard_report" element={<EmployeeTimeCardReport />} />




          </Route>

          {/* Catch-all route for unknown paths */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;